import { PagedResult, panelDelete, panelGet, panelPost, panelPut } from "./panel.api";
import { DivisionPayload, DivisionRecord } from "./types";

export interface DivisionListParams {
  page?: number;
  size?: number;
  searchText?: string;
  order?: string;
  orderBy?: string;
  subsidiary?: string;
}

/**
 * division — /division
 *
 * The API's "division" is what the Work Order / Approval Management UI labels
 * "Cost Centre". Keep the API names here and map at the screen.
 */
export const divisionApi = {
  /** Paged list backing the Approval Management "Cost Center" tab. */
  list: (params: DivisionListParams = {}) =>
    panelGet<PagedResult<DivisionRecord>>("/division/get-division-list", {
      page: 0,
      size: 20,
      orderBy: "division",
      ...params,
    }),
  all: () => panelGet<DivisionRecord[]>("/division/get-all-division"),
  /** Drives the Subsidiary → Cost Centre cascade used across the forms. */
  bySubsidiary: (subsidiary: string) =>
    panelGet<DivisionRecord[]>("/division/get-all-divisionBySubsidiary", { subsidiary }),
  detail: (divisionId: string) => panelGet<DivisionRecord>("/division/division-detail", { divisionId }),

  create: (payload: DivisionPayload) => panelPost("/division/create-division", payload),
  update: (payload: DivisionPayload) => panelPut("/division/update-division", payload),

  /** create-default takes an ARRAY; the others take a single object. */
  createDefault: (payload: DivisionPayload[], subsidiaryId?: string) =>
    panelPost("/division/create-default-division", payload, { subsidiaryId }),
  updateDefault: (payload: DivisionPayload) => panelPut("/division/update-default-division", payload),
  removeDefault: (divisionId: string) =>
    panelDelete("/division/delete-default-division", { divisionId }),
};
